import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Row, Col } from "antd";
import { ColumnsType } from "antd/es/table";
import styled from "@emotion/styled";
import { ListTable } from "components/table/list-table";
import { Job } from "../../job/all-jobs/list";
import { taskStatus, workingPeriodStatus } from "../../../utils/common";
import moment from "moment";

export interface TaskHelpers {
  uuid: string;
  status: number;
  task: Job;
}

export const JobList = (props: {
  jobs: TaskHelpers[];
  numOfReject: number;
  numOfCancelled: number;
  numOfLeave: number;
  numOfAbsence: number;
}) => {
  const navigate = useNavigate();

  const columns: ColumnsType<TaskHelpers> = [
    {
      title: "job number",
      dataIndex: ["task", "taskNo"],
      key: "taskNo",
      render: (text, record) => <a href={`/job/${record.task.uuid}`}>{text}</a>,
    },
    {
      title: "caption",
      dataIndex: ["task", "title"],
      key: "title",
    },
    {
      title: "employer",
      dataIndex: ["task", "employer", "companyName"],
      key: "employerName",
      render: (text, record) =>
        record.task.employer?.companyName ||
        record.task.employer?.contactPerson,
    },
    {
      title: "working status",
      dataIndex: ["task", "status"],
      key: "status",
      render: (text, record) => taskStatus(parseInt(text)),
    },
    {
      title: "operating hours",
      dataIndex: ["task", "startTime"],
      key: "startTime",
      render: (text, record) => moment(text, "HH:mm:ss").format("HH:mm"),
    },
    {
      title: "start date",
      dataIndex: ["task", "startDate"],
      key: "startDate",
    },
    {
      title: "period",
      dataIndex: ["task", "workingPeriod"],
      key: "workingPeriod",
      render: (text, record) => workingPeriodStatus(parseInt(text)),
    },
  ];

  const { jobs, numOfReject, numOfCancelled, numOfLeave, numOfAbsence } = props;

  return (
    <>
      <OtherDataContainer>
        <Row>
          <Col span={6}>
            <JobStatusDataContainer>
              <OtherDataTitle>refuse employment to employer</OtherDataTitle>
              <OtherDataText>{numOfReject}</OtherDataText>
            </JobStatusDataContainer>
          </Col>
          <Col span={6}>
            <JobStatusDataContainer>
              <OtherDataTitle>job canceled</OtherDataTitle>
              <OtherDataText>{numOfCancelled}</OtherDataText>
            </JobStatusDataContainer>
          </Col>
          <Col span={6}>
            <JobStatusDataContainer>
              <OtherDataTitle>give up job</OtherDataTitle>
              <OtherDataText>{numOfLeave}</OtherDataText>
            </JobStatusDataContainer>
          </Col>
          <Col span={6}>
            <JobStatusDataContainer>
              <OtherDataTitle>unexcused absence from job</OtherDataTitle>
              <OtherDataText>{numOfAbsence}</OtherDataText>
            </JobStatusDataContainer>
          </Col>
        </Row>
      </OtherDataContainer>
      <Table<TaskHelpers>
        columns={columns}
        dataSource={jobs}
        // pagination={{ current: 1, total: 100 }}
      />
    </>
  );
};

const OtherDataContainer = styled.div`
  padding-bottom: 25px;
`;

const OtherDataTitle = styled.div`
  color: #8d939e;
  font-size: 12px;
  font-weight: 500;
  padding-bottom: 5px;
`;

const OtherDataText = styled.div`
  color: #3c3e42;
  font-size: 24px;
  font-weight: 500;
`;

const JobStatusDataContainer = styled.div`
  background-color: #ffffff;
  padding: 16px 20px;
  margin: 0 20px;
  text-align: center;
  border-radius: 8px;
`;
